module.exports = __webpack_public_path__ + "static/media/resource.9ad2d4df.svg";